import { observer } from 'mobx-react-lite';
import { Form, Formik } from 'formik';
import Popup from '../../../../components/common-components/pop-up/Popup';
import { Clock } from 'lucide-react';
import { useStore } from '../../../../hooks/useStore';
import FormPopupFooter from '../../../../components/form-components/common-components/FormPopupFooter';
import { EditOvertimeFormSchema } from '../../../../schemas/OvertimeFormSchema';
import {
  getEditOvertimeFormValues,
  parseFormDates,
  type OvertimeFormValues,
} from './overtimeFormUtils';
import OvertimeFormFields from './OvertimeFormFields';
import styles from './NewOvertimePopup.module.css';

const EditOvertimePopup = () => {
  const { popupStore, overtimeStore, authStore } = useStore();
  const selectedOvertime = overtimeStore.selectedOvertime;

  const handleClose = () => {
    popupStore.setIsEditOvertimeOpen(false);
    overtimeStore.setSelectedOvertime(null);
  };

  const handleSubmit = async (values: OvertimeFormValues) => {
    if (!selectedOvertime) {
      return;
    }

    const { startDate, endDate } = parseFormDates(values);

    await overtimeStore.updateOvertime(selectedOvertime.id, {
      startDate,
      endDate,
      description: values.description,
      status: values.status,
      rejectionReason: values.status === 'Rejected' ? values.rejectionReason : undefined,
      overtimeType: selectedOvertime.overtimeType,
    });

    popupStore.setIsEditOvertimeOpen(false);
    overtimeStore.setSelectedOvertime(null);
  };

  if (!popupStore.isEditOvertimeOpen || !selectedOvertime) {
    return null;
  }

  const isAdmin = authStore.hasAnyRole(['Admin']);

  return (
    <Formik
      initialValues={getEditOvertimeFormValues(selectedOvertime)}
      validationSchema={EditOvertimeFormSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {() => (
        <Popup
          isOpen={popupStore.isEditOvertimeOpen}
          onClose={handleClose}
          title="Mesai Kaydını Düzenle"
          description="Mesai kaydını güncelleyin"
          variant="success"
          icon={<Clock size={22} strokeWidth={2} />}
          footer={() => (
            <FormPopupFooter
              onClose={handleClose}
              saveLabel="Güncelle"
              submittingLabel="Güncelleniyor..."
            />
          )}
        >
          <Form className={styles.form}>
            <OvertimeFormFields
              descriptionPlaceholder="Mesai açıklamasını giriniz..."
              showStatus={isAdmin}
            />
          </Form>
        </Popup>
      )}
    </Formik>
  );
};

export default observer(EditOvertimePopup);
